import { HelmetDexteel } from "@dexteel/mesf-core";
import { Warning as WarningIcon } from "@mui/icons-material";
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	Grid2,
	Typography,
} from "@mui/material";
import React from "react";

type Props = {
	open: boolean;
	onClose: (event?: {}, reason?: "backdropClick" | "escapeKeyDown") => void;
	title?: string;
	message?: string;
	suffixTitle?: string;
};

export const WarningModal = ({
	open,
	onClose,
	title = "Warning",
	message,
	suffixTitle,
}: Props) => {
	if (!open) {
		return null;
	}

	return (
		<>
			<HelmetDexteel
				title={`${title}${suffixTitle ? ` - ${suffixTitle}` : ""}`}
			/>
			<Dialog
				open={open}
				onClose={() => onClose()}
				maxWidth="sm"
				fullWidth
				sx={{
					"& .MuiDialog-paper": {
						borderLeft: (theme) => `8px solid ${theme.palette.warning.main}`,
					},
				}}
			>
				<DialogContent
					sx={{
						backgroundColor: (theme) => theme.palette.background.default,
						padding: (theme) => theme.spacing(3),
					}}
				>
					<Grid2>
						<Box display="flex" style={{ gap: 10 }}>
							<WarningIcon color="warning" />
							<Typography variant="h6">Warning</Typography>
						</Box>
						<Box>
							<Typography
								sx={{
									marginTop: (theme) => theme.spacing(2),
									paddingLeft: (theme) => theme.spacing(5),
									color: (theme) => theme.palette.action.active,
								}}
							>
								{message &&
									message.split("|").map((line, index) => (
										<React.Fragment key={index}>
											{line.trim()}
											{index < message.split("|").length - 1 && <br />}
										</React.Fragment>
									))}
							</Typography>
						</Box>
					</Grid2>
				</DialogContent>

				<DialogActions
					sx={{
						justifyContent: "flex-end",
						backgroundColor: (theme) => theme.palette.background.default,
						padding: (theme) => theme.spacing(0, 3, 3),
					}}
				>
					<Button onClick={() => onClose()} variant="text" autoFocus>
						Ok
					</Button>
				</DialogActions>
			</Dialog>
		</>
	);
};
